module.exports = __webpack_public_path__ + "WS.png?bf46e064c35dfabe5ff27d3ac67075e7";